import { render, staticRenderFns } from "./ModalEditarPaciente.vue?vue&type=template&id=83cc2612&scoped=true"
import script from "./ModalEditarPaciente.vue?vue&type=script&lang=ts"
export * from "./ModalEditarPaciente.vue?vue&type=script&lang=ts"
import style0 from "./ModalEditarPaciente.vue?vue&type=style&index=0&id=83cc2612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cc2612",
  null
  
)

export default component.exports